import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hsl'
})
export class HslPipe implements PipeTransform {

  transform(value: string): unknown {
    var saturation = 40;
    var lightness =  50;
		if (!value) return "";

		var hash = 0;
		for (var i = 0; i < value.length; i++) {
			hash = value.charCodeAt(i) + ((hash << 5) - hash);
		}

		var h = hash % 200;
		return 'hsl('+h+', '+saturation+'%, '+lightness+'%)';  }

}
